import { Component, OnInit } from "@angular/core";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";
import * as moment from "moment";
import { AlergiasService } from "src/services/alergias.service";
import { GlicoseService } from "src/services/glicose.service";
import { ImcService } from "src/services/imc.service";
import { MedicamentosService } from "src/services/medicamentos.service";
import { PressaoService } from "src/services/pressao.service";

@Component({
  selector: "app-registros-autodeclarados-component",
  templateUrl: "./registros-autodeclarados-component.component.html",
  styleUrls: ["./registros-autodeclarados-component.component.scss"],
})
export class RegistrosAutodeclaradosComponentComponent implements OnInit {
  emptyState = {
    imgUrl: "/assets/imgs/bg-alergias.svg",
    title: "O paciente não possui registros autodeclarados",
    text: "O paciente não declarou nenhum registro médico.",
  };

  emptyStateFiltered = {
    imgUrl: "/assets/imgs/bg-alergias.svg",
    title:
      "O paciente não declarou nenhum registro médico, com o filtro aplicado",
    text: "O paciente não declarou nenhum registro médico, com o filtro aplicado.",
  };

  registrosDeclaradosList: any[] = [];
  registrosDeclaradosListFiltered: any[] = [];
  dtFim: any;
  dtInicio: any;
  conteudoRevelado = false;
  listaFiltro: any[] = [];
  filtrosSelecionados: any[] = [];

  listAlergias: any[] = [];
  pressaoList: any[] = [];
  glicoseList: any[] = [];
  imcList: any[] = [];
  medDeclaradosList: any[] = [];

  constructor(
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private pressaoService: PressaoService,
    private alergiaService: AlergiasService,
    private glicoseService: GlicoseService,
    private imcService: ImcService,
    private medicamentosService: MedicamentosService
  ) { }

  async ngOnInit() {
    this.loadingCtrl.create();
    await this.loadData();

    this.registrosDeclaradosList.forEach((reg) => {
      if (!this.listaFiltro.includes(reg.tipo)) {
        this.listaFiltro.push(reg.tipo);
      }
    });

    this.loadingCtrl.dismiss();

  }

  async loadData() {
    this.pressaoList = await this.pressaoService.recuperar();

    this.listAlergias = await this.alergiaService.recuperarMinhasAlergias();

    this.glicoseList = await this.glicoseService.recuperar();

    this.imcList = await this.imcService.recuperar();

    this.medDeclaradosList = await this.medicamentosService.recuperarMedicamentos();

    this.formatarConteudo(false);
  }

  formatarConteudo(hidden: boolean) {
    if (this.listAlergias.length) {
      const aux = [
        {
          tipo: "ALERGIAS",
          nome: "Alergias",
          tipoAlergia: "medicamentos",
          listaAlergia: [],
          dtAtualizacao: "-",
        },
        {
          tipo: "ALERGIAS",
          nome: "Alergias",
          tipoAlergia: "alimentos",
          listaAlergia: [],
          dtAtualizacao: "-",
        },
        {
          tipo: "ALERGIAS",
          nome: "Alergias",
          tipoAlergia: "animais",
          listaAlergia: [],
          dtAtualizacao: "-",
        },
      ];

      for (let alergia of this.listAlergias) {
        if (alergia.nome === "Outra Alergia") {
          aux[2].listaAlergia.push(alergia);
        }
        if (alergia.nome === "Outra Alergia Alimentar") {
          aux[1].listaAlergia.push(alergia);
        }
        if (alergia.nome === "Outra Alergia Medicamentosa") {
          aux[0].listaAlergia.push(alergia);
        }
      }
      for (let al of aux) {
        this.registrosDeclaradosList.push(al);
      }
    }

    if (this.pressaoList.length) {
      this.pressaoList.forEach((pressao) => {
        this.registrosDeclaradosList.push({
          tipo: "PRESSAO",
          nome: "Pressão",
          dtAtualizacao: pressao.dataExame,
          precaoMax: pressao.paMax,
          precaoMin: pressao.paMin,
          precaoIdeal: "-",
          dateStamp: pressao.dataExame,
        });
      });
    }

    if (this.glicoseList.length) {
      this.glicoseList.forEach((glicose) => {
        this.registrosDeclaradosList.push({
          tipo: "GLICOSE",
          nome: "Glicose",
          dtAtualizacao: glicose.dataExame,
          resultado: glicose.resultado,
          dateStamp: glicose.dataExame,
        });
      });
    }

    if (this.imcList.length) {
      this.imcList.forEach((imc) => {
        this.registrosDeclaradosList.push({
          tipo: "IMC",
          nome: "IMC",
          dtAtualizacao: imc.data,
          imc: imc.imc,
          dateStamp: imc.data,
        });
      });
    }

    if (this.medDeclaradosList.length) {
      this.medDeclaradosList.forEach((med) => {
        this.registrosDeclaradosList.push({
          tipo: "MEDICAMENTOS DECLARADOS",
          nome: "Medicamentos declarados",
          dtAtualizacao: "-",
          medicamentoNome: med.nome,
          observacao: med.descricao,
        });
      });
    }

    if (hidden) {
      this.registrosDeclaradosListFiltered = this.registrosDeclaradosList.slice(
        0,
        3
      );
    }
  }

  revelarConteudo() {
    this.registrosDeclaradosListFiltered = this.registrosDeclaradosList;
    this.conteudoRevelado = true;
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.registrosDeclaradosListFiltered =
        this.registrosDeclaradosListFiltered.filter((atendimento) => {
          if (atendimento.dateStamp) {
            const dtAtendimento = moment(atendimento.dateStamp);
            const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(
              1,
              "d"
            );
            const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");
            return dtAtendimento.isBetween(dtInicio, dtFim);
          }
          return false;
        });
    }

    if (this.filtrosSelecionados.length) {
      this.registrosDeclaradosListFiltered =
        this.registrosDeclaradosListFiltered.filter((reg) => {
          return this.filtrosSelecionados.includes(
            reg.tipo.toLocaleLowerCase()
          );
        });
    }
  }

  getPressaoStatus(pressao) {
    if (!pressao) {
      return " - ";
    }
    if (pressao.precaoMax <= 120) {
      return "Normal";
    } else if (pressao.precaoMin < 121) {
      return "Pré-hipertensão";
    } else {
      return "Hipertensão";
    }
  }

  addFilter(data) {
    if (!data) {
      return;
    }
    this.revelarConteudo();

    if (!this.filtrosSelecionados.includes(data)) {
      this.filtrosSelecionados.push(data.toLowerCase());
    }

    this.filter();
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
    this.registrosDeclaradosListFiltered = this.registrosDeclaradosList;
  }
}
